<div class="modal-wrapper">
    <h1 class="emoji">✋</h1>
    <h2 class="heading">{{'syndicate-member-popup.enough' | translate}}</h2>
    <h6 class="sub-heading">
        {{'syndicate-member-popup.need' | translate}}
    </h6>
    <ion-row>
        <ion-button expand="block" color="medium" class="capsule-btn " type="submit" (click)="inviteMember()">
            {{'syndicate-member-popup.Invite' | translate}}</ion-button>
        <h6 class="decline-text" (click)="close()">{{'syndicate-member-popup.later' | translate}}</h6>
    </ion-row>
</div>